import { render, staticRenderFns } from "./addCarScetchQ.vue?vue&type=template&id=24d66db0&"
import script from "./addCarScetchQ.vue?vue&type=script&lang=js&"
export * from "./addCarScetchQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports